export const APP = {
    IDENTITY: 'client',
    NAME: process.env.ENV.APP_NAME,
    VERSION_COMMIT_SHA: process.env.ENV.VERSION_COMMIT_SHA || '',
    VERSION_COMMIT_DATE: process.env.ENV.VERSION_COMMIT_DATE
        ? process.env.ENV.VERSION_COMMIT_DATE
        : '',
    VERSION_BRANCH: process.env.ENV.VERSION_BRANCH || '',
    BUILD_DATE: process.env.ENV.BUILD_DATE || '',
    ROUTES: {
        ENTRY: '/',
        MARKETING_CHANNEL: '/marketingChannel',
        CONTACT_INFO: '/contactInfo',
        CONTRACT: '/contract',
        HOSPITAL: '/hospital',
        HOSPITAL_CONFIRMATION: '/hospitalConfirmation',
        PATIENT_INFO: '/patientInfo',
        CARE_REQUIREMENT: '/careRequirement',
        NOTES_AND_AGREEMENT: '/notesAndAgreement',
        DATE_AND_TIME: '/dateAndTime',
        DETAIL_CONFIRMATION: '/detailConfirmation',
        TRANSFER_INSTRUCTION: '/transferInstruction',
    },
    TOTAL_PAGE_PROGRESS_COUNT: 9,
    PAGE_PROGRESS_INFO: {
        '/contactInfo': {
            progress: 1,
            title: '您的聯繫資訊',
        },
        '/contract': {
            progress: 2,
            title: '合約確認',
        },
        '/hospital': {
            progress: 3,
            title: '選擇服務地點',
        },
        '/hospitalConfirmation': {
            progress: 3,
            title: '確認服務地點',
        },
        '/patientInfo': {
            progress: 4,
            title: '病患狀況',
        },
        '/careRequirement': {
            progress: 5,
            title: '照顧需求',
        },
        '/notesAndAgreement': {
            progress: 6,
            title: '備註與同意事項',
        },
        '/dateAndTime': {
            progress: 7,
            title: '照顧方案與時間',
        },
        '/detailConfirmation': {
            progress: 8,
            title: '費用試算',
        },
        '/transferInstruction': {
            progress: 9,
            title: '綁定LINE帳號',
        },
    },
    DAYJS_LOCALE: 'zh-tw',
};
export const ORDERED_APP_ROUTE_LIST = [
    APP.ROUTES.ENTRY,
    APP.ROUTES.MARKETING_CHANNEL,
    APP.ROUTES.CONTACT_INFO,
    APP.ROUTES.CONTRACT,
    APP.ROUTES.HOSPITAL,
    APP.ROUTES.HOSPITAL_CONFIRMATION,
    APP.ROUTES.PATIENT_INFO,
    APP.ROUTES.CARE_REQUIREMENT,
    APP.ROUTES.NOTES_AND_AGREEMENT,
    APP.ROUTES.DATE_AND_TIME,
    APP.ROUTES.DETAIL_CONFIRMATION,
    APP.ROUTES.TRANSFER_INSTRUCTION,
];
